export const CHECKOUT_WORKFLOWS = {
    ACCOUNT_FORM: 1,
    PAYMENT_METHODS: 2
}
